export function dateFormatter(date: string): string
{
    ///date viene en forma dd/MM/YYYY
    let d = date.substring(0, 10).split("-");
    return d[2]+"/"+d[1]+"/"+d[0];
}